// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"login_loginPage__26b8S","login":"login_login__gwXZ1","form":"login_form__uMm4R","actions":"login_actions__MYC0Z"};